module.exports = function getResource(label, vars = []) {
    let resources = {
        new: 'New'
    };
    return resources[label];
};
